<sk-drawer [(open)]="open" [title]="'layout.notifications.title' | transloco" placement="right" size="md">
  <!-- Header actions -->
  <div class="flex items-center justify-between mb-4">
    <span class="text-sm text-sk-text-secondary">
      {{ 'layout.notifications.summary' | transloco: { unread: service.unreadCount(), total: service.items().length } }}
    </span>
    <div class="flex gap-2">
      @if (service.items().length > 0) {
        <sk-button variant="ghost" size="sm" (skClick)="service.markAllRead()">
          {{ 'layout.notifications.markAllRead' | transloco }}
        </sk-button>
        <sk-button variant="ghost" size="sm" [attr.aria-label]="'layout.notifications.clearHistory' | transloco" (skClick)="service.clear()">
          <sk-icon name="trash" size="sm" />
        </sk-button>
      }
    </div>
  </div>

  <!-- What's new: every release, newest first. Selecting one closes the drawer and opens the modal on it. -->
  <section class="mb-4">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-sk-text-secondary mb-2">{{ 'layout.notifications.whatsNew' | transloco }}</h3>
    <sk-whats-new-feed (open)="open.set(false)" />
  </section>

  <!-- Empty state -->
  @if (service.items().length === 0) {
    <sk-empty-state
      [title]="'layout.notifications.emptyTitle' | transloco"
      [description]="'layout.notifications.emptyDescription' | transloco" />
  }

  <!-- Notification list -->
  @for (notif of service.items(); track notif.id) {
    <div
      class="nf-card-interactive mb-2 transition-opacity cursor-pointer"
      [class.opacity-50]="notif.read"
      (click)="openDetail(notif)">

      <div class="flex items-start gap-3 p-3">
        <sk-icon
          [name]="statusIcon(notif.status)"
          size="sm"
          class="mt-0.5 flex-shrink-0"
          [style.color]="'var(--sk-color-' + (notif.status === 'error' ? 'danger' : notif.status) + '-500)'" />

        <div class="flex-1 min-w-0">
          <div class="flex items-center gap-2 mb-1">
            @if (notif.statusCode !== undefined) {
              <sk-badge [variant]="badgeVariant(notif.status)">{{ notif.statusCode }}</sk-badge>
            }
            <span class="text-xs font-medium truncate text-sk-text">
              {{ notif.title }}
            </span>
          </div>
          <p class="text-xs truncate mb-1 text-sk-text-secondary">
            {{ notif.message }}
          </p>
          <p class="text-xs tabular-nums text-sk-text-secondary">
            {{ notif.timestamp | nfDate: dateLocale() : 'timeSeconds' }}
          </p>
        </div>

        <div class="flex gap-1 flex-shrink-0" (click)="$event.stopPropagation()">
          <sk-button variant="ghost" size="sm" [attr.aria-label]="'layout.notifications.viewDetail' | transloco" (skClick)="openDetail(notif)">
            <sk-icon name="eye" size="sm" />
          </sk-button>
          <sk-button variant="ghost" size="sm" [attr.aria-label]="'layout.notifications.remove' | transloco" (skClick)="service.remove(notif.id)">
            <sk-icon name="x" size="sm" />
          </sk-button>
        </div>
      </div>
    </div>
  }
</sk-drawer>
